<template>
  <div class="rt-content-wrapper">
    <div
      class="rt-content-main"
      :style="computedStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtContent',
  props: {
    contentMainStyle: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasAside () {
      return !!this.$slots.aside;
    },
    computedStyle () {
      return this.contentMainStyle || ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtContent.vue?8643254c